import React, { useState, useEffect } from "react";
import SearchLabel from "../../../components/doctorComponents/form/search/searchLabel";
import PatientFileCard from "../../../components/doctorComponents/patientFileCard";
import {
  callApi,
  getEpsInstitutionList,
} from "../../../services/doctorServices/apiService";
import { NotificationManager } from "react-notifications";
import Progress from "../../../components/doctorComponents/Progress";
import { isRole } from "../../../services/doctorServices/userService";
import { RoleEnum , InstitutionListTypeEnum} from "../../../constants/doctorConstants/enums";

const filterList = (list, searchText, currentFilerStatus) => {
  let result = [...list];
  if (currentFilerStatus && currentFilerStatus > 1) {
    result = result.filter(
      (x) =>
        (currentFilerStatus === 2 && x.registered === true) ||
        (currentFilerStatus === 3 && x.registered === false)
    );
  }
  if (searchText) {
    const text = searchText.toUpperCase();
    result = result.filter(
      (x) => x.fullName && x.fullName.toUpperCase().includes(text)
    );
  }
  return result;
};

const EpsList = () => {
  const [loader, setLoader] = useState(false);
  const [epsList, setEpsList] = useState([]);
  const [searchText, setSearchText] = useState(null);
  const [currentEps, setCurrentEps] = useState(null);
  const [dlgDoctorInv, setDlgDoctorInv] = useState(false);

  const isInstitution = isRole(RoleEnum.institution);

  const [currentFilerStatus, setCurrentFilerStatus] = useState(null);

  useEffect(() => {
    if (isInstitution) {
      callApi(
        getEpsInstitutionList,
        (data) => {
          if (data && data.length === 0) {
            NotificationManager.warning("No tiene EPS asociadas");
            return;
          }
          setEpsList(data);
        },
        setLoader
      );
      return;
    }
  }, []);

  return (
    <div className="container">
      <div className="inner-container">
        {epsList && epsList.length > 0 && (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="file-info" style={{ width: "355px" }}>
                <SearchLabel
                  placeholder="Buscar EPS"
                  setSearchText={setSearchText}
                />
              </div>
            </div>
          </>
        )}
        {filterList(epsList, searchText, currentFilerStatus).map(
          (item, index) => {
            return (
              <PatientFileCard
                key={index}
                item={item}
                name={item.fullName}
                cicle={item.patientQuantity}
                instillation={item.surveyQuantity ?? ""}
                registered={item.registered}
                email={item.email ?? ""}
                phone={item.telephone ?? ""}
                link="/doctor/eps-list/eps-details"
                setCurrentEps={setCurrentEps}
                institutionListType = {InstitutionListTypeEnum.epsList}
              />
            );
          }
        )}
      </div>
      <Progress loader={loader} />
    </div>
  );
};

export default EpsList;
